import { apiFetch } from './api-fetch';
import { keys } from './query-keys';

export const STATIC_QUERY_STALE_TIME = 1000 * 60 * 60 * 12;

export function applyBootstrapQueryDefaults(queryClient) {
  queryClient.setQueryDefaults(keys.paymentMethods.all(), {
    staleTime: STATIC_QUERY_STALE_TIME,
  });
  queryClient.setQueryDefaults(keys.services.all(), {
    staleTime: STATIC_QUERY_STALE_TIME,
  });
  queryClient.setQueryDefaults(keys.products.all(), {
    staleTime: STATIC_QUERY_STALE_TIME,
  });
  queryClient.setQueryDefaults(keys.staff.all(), {
    staleTime: STATIC_QUERY_STALE_TIME,
  });
}

function getCurrentMonthMetricsRange() {
  const now = new Date();
  const from = new Date(now);
  from.setDate(1);
  from.setHours(0, 0, 0, 0);

  const to = new Date(now);
  to.setHours(23, 59, 59, 999);

  return {
    from: from.toISOString(),
    to: to.toISOString(),
  };
}

export async function prefetchCoreAppData(queryClient, session) {
  if (!session?.user?.id) return;

  const metricsRange = getCurrentMonthMetricsRange();

  await Promise.allSettled([
    queryClient.prefetchQuery({
      queryKey: keys.customers.list({
        page: 1,
        limit: 5,
        search: '',
        sortBy: 'createdAt',
        sortDirection: 'desc',
      }),
      queryFn: () =>
        apiFetch('/customers?page=1&limit=5&search=&sortBy=createdAt&sortDirection=desc'),
    }),
    queryClient.prefetchQuery({
      queryKey: keys.sales.list({
        page: 1,
        limit: 10,
        timeFilter: 'day',
        staffId: undefined,
        paymentMethodId: undefined,
        saleType: undefined,
        from: undefined,
        to: undefined,
      }),
      queryFn: () => apiFetch('/sales?page=1&limit=10&timeFilter=day'),
    }),
    queryClient.prefetchQuery({
      queryKey: keys.metrics.summary(session.user.id, metricsRange.from, metricsRange.to, 'all'),
      queryFn: () =>
        apiFetch(`/metrics/summary?from=${encodeURIComponent(metricsRange.from)}&to=${encodeURIComponent(metricsRange.to)}`),
    }),
    queryClient.prefetchQuery({
      queryKey: keys.customers.list({ page: 1, limit: 50, search: '' }),
      queryFn: () => apiFetch('/customers?page=1&limit=50'),
    }),
    queryClient.prefetchQuery({
      queryKey: keys.products.list(),
      queryFn: () => apiFetch('/products?limit=50'),
    }),
    queryClient.prefetchQuery({
      queryKey: keys.services.list(),
      queryFn: () => apiFetch('/services?limit=50'),
    }),
    queryClient.prefetchQuery({
      queryKey: keys.paymentMethods.all(),
      queryFn: () => apiFetch('/payment-methods'),
    }),
    queryClient.prefetchQuery({
      queryKey: keys.staff.list({ page: 1, limit: 50 }),
      queryFn: () => apiFetch('/staff?page=1&limit=50'),
    }),
  ]);
}
